var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.902 15.145a8.896 8.896 0 0 0-4.383-3.84 5.48 5.48 0 1 0-6.577 0 8.896 8.896 0 0 0-4.383 3.84.866.866 0 1 0 1.498.865c1.307-2.259 3.614-3.606 6.174-3.606 2.56 0 4.867 1.348 6.174 3.606a.865.865 0 0 0 1.497-.866zM5.481 6.923a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0z",
    fill: "#253331"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e0cb3cf7cc35570905bfd7415c975943.svg";
export { ForwardRef as ReactComponent };